module.exports = __webpack_public_path__ + "static/media/paradi_logo01 copy.e916fca0.png";